<template>
  <div style="font-family: Arial, sans-serif; font-size: 13px; color: #333;">
    <div v-if="!claimInternalBillDetails" style="padding: 12px; color: #666;">
      Loading claim details...
    </div>

    <div v-else>
      <div style="border: 1px solid #E0E0E0; padding: 12px; margin-bottom: 12px; background: #f9fbff;">
        <div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">Claim Information</div>
        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
          <div style="min-width: 220px;">
            <div style="margin-bottom: 4px;"><strong>Claim Date:</strong> {{ claimInternalBillDetails?.date || "-" }}</div>
          </div>
          <div style="min-width: 220px;">
            <div style="margin-bottom: 4px;"><strong>Created By:</strong> {{ claimInternalBillDetails?.created_by?.full_name || "-" }}</div>
            <div style="margin-bottom: 4px;"><strong>Remarks:</strong> {{ claimInternalBillDetails?.remarks || "-" }}</div>
          </div>
        </div>
      </div>

      <table style="width: 100%; border-collapse: collapse; border: 1px solid #E0E0E0;">
        <thead>
          <tr>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Claim Type</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Movement Type</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Company</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Description</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">From Address</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">To Address</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Travelled By</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Claim Date</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: right; background: #f5f5f5;">Req. Amt.</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: right; background: #f5f5f5;"><span class="text-red-accent-4">*</span> Acc. Amt.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="detail in claimDetails || []" :key="detail?.id">
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.claim_type || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.movement_type || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.company_name || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.description || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.from_address || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.to_address || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.travelled_by || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ detail?.claim_date || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px; text-align: right;">{{ detail?.requested_amount || "-" }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px; text-align: right; width: 130px;" >
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                type="number"
                v-model.number="detail.accepted_amount"
                :min="0"
                :max="detail.requested_amount"
                @update:model-value="validateAcceptedAmount(detail)"
                hide-spin-buttons
                clearable
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { useField } from 'vee-validate';
import { ref } from 'vue';

export default {
  name: "hrmClaimDetailsTable",
  props: {
    claimData: Object,
  },
  data() {
    return {
      claimInternalBillDetails: null,
      claimDetails : [
        {
          claim_detail_id: null,
          claim_type: null,
          movement_type: null,
          meeting_id: null,
          company_name: null,
          description: null,
          from_address: null,
          to_address: null,
          travelled_by: null,
          claim_date: null,
          type: null,
          requested_amount: null,
          accepted_amount: null
        },
      ]
    };
  },

  methods: {
    validateAcceptedAmount(detail) {
      let value = Number(detail.accepted_amount);

      if (isNaN(value)) {
        detail.accepted_amount = 0;
        return;
      }

      if (value < 0) {
        detail.accepted_amount = 0;
      }

      if (value > detail.requested_amount) {
        detail.accepted_amount = detail.requested_amount;
      }
    }
  },

  setup() {
  },

  mounted() {
    const id = this.$route.query.referenceable_id;

    if (id) {
      this.$store.dispatch("getClaimById", id)
        .then((res) => {
          this.claimInternalBillDetails = res?.data?.data;
          this.claimDetails = [];

          console.log(this.claimInternalBillDetails)

          this.claimInternalBillDetails?.details?.forEach((data) => {
            this.claimDetails?.push({
              claim_detail_id: data?.id,
              claim_type: data?.claim_type?.name,
              movement_type: data?.meeting?.movement_type,
              meeting_id: data?.meeting_id,
              company_name: data?.meeting?.company_name,
              description: data?.description,
              from_address: data?.from_address,
              to_address: data?.to_address,
              travelled_by: data?.travelled_by,
              claim_date: data?.claim_date,
              type: data?.claim_type?.name,
              requested_amount: data?.amount,
              accepted_amount: data?.amount
            })
          })

          const claimData = {
            claim_master_id: this.claimInternalBillDetails?.id,
            claim_details: this.claimDetails
          }

          this.$emit("update-claim-details", claimData);

        })
        .catch(() => {
          this.claimInternalBillDetails = null;
        });
    }
  },
};
</script>